(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('info-admin', {
                parent: 'entity',
                url: '/infos-administration',
                title:'Envoyer',
                sidebarMeta: {
                    icon: 'glyphicon glyphicon-tower',
                    order: 9
                },
                data: {
                    authorities: ['ROLE_RESPONSABLE_INSCRIPTION', 'ROLE_RESPONSABLE', 'ROLE_ADMIN'],
                    pageTitle: 'josdaviApp.classe.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/info-administrative/info-admin.html',
                        controller: 'InfoAdminController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {}
            });
    }

})();
